import { createAction } from '@reduxjs/toolkit';

import {
  TOGGLE_NEW_EXPERIENCE_MODAL,
  CREATE_EXPERIENCE_REQUEST,
  FETCH_EXPERIENCE_REQUEST,
  FETCH_EXPERIENCES_REQUEST,
  UPDATE_EXPERIENCE_REQUEST,
  SET_EXPERIENCE_LENGTH,
  UPDATE_TOUR_STEP_FORM,
  CREATE_PHOTO_REQUEST,
  REMOVE_PHOTO_REQUEST,
  MOVE_PHOTO_REQUEST,
  TOGGLE_CHANGES_MODAL,
  MOBILE_TABS_MENU_TOGGLED,
  REQUEST_STEP_SELECTED,
  LOCATION_SEARCHED,
  LOCATION_SELECTED,
  UPDATE_EXPERIENCE_ERRORS_ACKNOWLEDGED,
  SAVE_AND_EXIT,
  CREATE_EXPERIENCE_MEETING_REQUEST,
  UPDATE_EXPERIENCE_MEETING_REQUEST,
} from './experienceActionTypes';

export const toggleNewExperienceModal = (visible, resourceId = null) => {
  return {
    type: TOGGLE_NEW_EXPERIENCE_MODAL,
    visible,
    resourceId,
  };
};

export const createExperience = (
  resourceId,
  { name, customTypeId, online }
) => {
  return {
    type: CREATE_EXPERIENCE_REQUEST,
    resourceId,
    name,
    customTypeId,
    online,
  };
};

export const fetchExperience = (id, resourceId) => {
  return {
    type: FETCH_EXPERIENCE_REQUEST,
    id,
    resourceId,
  };
};

export const fetchExperiences = (resourceId) => {
  return {
    type: FETCH_EXPERIENCES_REQUEST,
    resourceId,
  };
};

// Update (Api/Saga)
export const updateExperience = (values, nextStep = false) => {
  return {
    type: UPDATE_EXPERIENCE_REQUEST,
    values,
    nextStep,
  };
};

export const createExperienceMeetingInfo = (values) => {
  return {
    type: CREATE_EXPERIENCE_MEETING_REQUEST,
    values,
  };
};

export const updateExperienceMeetingInfo = (values) => {
  return {
    type: UPDATE_EXPERIENCE_MEETING_REQUEST,
    values,
  };
};

export const setExperienceLength = (length) => {
  return {
    type: SET_EXPERIENCE_LENGTH,
    length,
  };
};

// Updates current step form
export const updateTourStepForm = (tourStepForm) => {
  return {
    type: UPDATE_TOUR_STEP_FORM,
    tourStepForm,
  };
};
// --

/* Photos */
// Create new photo (Api/Saga)
export const createPhoto = (attrs) => {
  return {
    type: CREATE_PHOTO_REQUEST,
    attrs,
  };
};

// Remove photo (Api/Saga)
export const removePhoto = (attrs) => {
  return {
    type: REMOVE_PHOTO_REQUEST,
    attrs,
  };
};

// Drag/Sort (Api/Saga)
export const repositionPhoto = (attrs) => {
  return {
    type: MOVE_PHOTO_REQUEST,
    attrs,
  };
};

// Toggle visibility of save/discard changes modal
export const toggleChangesModal = (visible, redirectTo = null) => {
  return {
    type: TOGGLE_CHANGES_MODAL,
    visible,
    redirectTo,
  };
};

// Mobile step/tab menu toggle
export const toggleMobileMenu = () => {
  return {
    type: MOBILE_TABS_MENU_TOGGLED,
  };
};

// Select tab/step
export const selectStep = (step) => {
  return {
    type: REQUEST_STEP_SELECTED,
    step,
  };
};

// Search for location (API/Saga)
export const locationSearch = (search) => {
  return {
    type: LOCATION_SEARCHED,
    search,
  };
};

// Select location from search results
export const selectLocation = (location) => {
  return {
    type: LOCATION_SELECTED,
    location,
  };
};

// user acknowledges errors that had occurred when trying to save a tour
export const acknowledgeExperienceErrors = () => ({
  type: UPDATE_EXPERIENCE_ERRORS_ACKNOWLEDGED,
});

export const experienceSelected = createAction(
  'resourcePortal/experienceSelected'
);
export const showAvailabilityModal = createAction(
  'resourcePortal/showAvailabilityModal'
);
export const cancelledCreateSchedule = createAction(
  'resourcePortal/cancelledCreateSchedule'
);
export const dateSelected = createAction('resourcePortal/dateSelected');
export const timeSelected = createAction('resourcePortal/timeSelected');
export const saveSchedule = createAction('resourcePortal/saveSchedule');
export const saveScheduleSucceeded = createAction(
  'resourcePortal/saveScheduleSucceeded'
);
export const saveScheduleFailed = createAction(
  'resourcePortal/saveScheduleFailed'
);

export const createScheduleSelected = createAction(
  'resourcePortal/createScheduleSelected'
);
export const fetchExperienceAvailabilityStarted = createAction(
  'resourcePortal/fetchExperienceAvailabilityStarted'
);
export const fetchExperienceAvailabilitySucceeded = createAction(
  'resourcePortal/fetchExperienceAvailabilitySucceeded'
);
export const fetchExperienceAvailabilityFailed = createAction(
  'resourcePortal/fetchExperienceAvailabilityFailed'
);
